import type {
  CalendarQuestionStatus,
  CalendarQuestion,
  CalendarQuestionText,
  CalendarQuestionSelectBox,
  CalendarQuestionInput,
} from '@/types/schema.generated'

// ここはただのenumなのでそのまま使う
export type { CalendarQuestionStatus } from '@/types/schema.generated'

export type TextQuestion = {
  type: 'TEXT'
  questionText: string
  status: CalendarQuestionStatus
}

export type SelectBoxQuestion = {
  type: 'SELECT_BOX'
  questionText: string
  status: CalendarQuestionStatus
  options: string[]
}

export type Question = TextQuestion | SelectBoxQuestion

export const getQuestionTypeName = (type: Question['type']): string => {
  switch (type) {
    case 'TEXT':
      return 'テキスト'
    case 'SELECT_BOX':
      return 'セレクトボックス'
    default:
      assertNever(type)
  }
}

export const statuses = ['OPTIONAL', 'REQUIRED'] as [
  CalendarQuestionStatus,
  CalendarQuestionStatus,
]

export const getQuestionStatusName = (
  status: CalendarQuestionStatus
): string => {
  switch (status) {
    case 'OPTIONAL':
      return '任意'
    case 'REQUIRED':
      return '必須'
    default:
      assertNever(status)
  }
}

export function fromGQLCalendarQuestion(
  question: CalendarQuestion &
    (CalendarQuestionText | CalendarQuestionSelectBox)
): Question {
  if (question.type === 'TEXT') {
    return {
      type: 'TEXT',
      questionText: question.questionText,
      status: question.status,
    }
  } else if (question.type === 'SELECT_BOX') {
    if (question.__typename !== 'CalendarQuestionSelectBox') {
      throw new Error(
        `Invalid question type for SELECT_BOX: received __typename = '${question.__typename}'`
      )
    }
    return {
      type: 'SELECT_BOX',
      questionText: question.questionText,
      status: question.status,
      options: question.options,
    }
  }

  throw new Error(`Unknown question type: ${question.type}`)
}

export function fromGQLCalendarQuestions(
  questions: (CalendarQuestion &
    (CalendarQuestionText | CalendarQuestionSelectBox))[]
): Question[] {
  const sortedQuestions = questions.toSorted((a, b) => a.order - b.order)
  return sortedQuestions.map(fromGQLCalendarQuestion)
}

function assertNever(x: never): never {
  throw new Error('Unexpected object: ' + x)
}

export function toGQLCalendarQuestionInput(
  question: Question,
  index: number
): CalendarQuestionInput {
  if (question.type === 'TEXT') {
    return {
      type: 'TEXT',
      questionText: question.questionText,
      status: question.status,
      order: index + 1,
    }
  } else if (question.type === 'SELECT_BOX') {
    return {
      type: 'SELECT_BOX',
      questionText: question.questionText,
      status: question.status,
      order: index + 1,
      options: question.options,
    }
  }

  assertNever(question)
}
